import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { boxInput, currentMonth } from "../lib/format";
import { AppHeader } from "../components/site/AppHeader";
import { TodayCard } from "../components/employee/TodayCard";
import { AttendanceSummary, AttendanceTable } from "../components/attendance/AttendanceTable";
import { PayslipList } from "../components/payslip/PayslipList";

export default function EmployeePortal() {
  const { user, logout } = useAuth();
  const [month, setMonth] = useState(currentMonth());
  const [att, setAtt] = useState([]);
  const [slips, setSlips] = useState([]);

  const loadAtt = useCallback(() => api.get("/me/attendance", { params: { month } }).then((r) => setAtt(Array.isArray(r.data) ? r.data : [])).catch(() => setAtt([])), [month]);

  useEffect(() => {
    if (user?.role === "employee") loadAtt();
    return undefined;
  }, [user, loadAtt]);

  useEffect(() => {
    if (user?.role === "employee") api.get("/me/payslips").then((r) => setSlips(Array.isArray(r.data) ? r.data : [])).catch(() => setSlips([]));
    return undefined;
  }, [user]);

  if (user === null) return <div className="min-h-screen bg-[var(--ink)]" />;
  if (!user || user.role !== "employee") return <Navigate to="/employee/login" replace />;

  return (
    <main className="min-h-screen bg-[var(--ink)] pb-24" data-testid="employee-portal">
      <AppHeader onLogout={logout} home="/employee" />
      <div className="mx-auto max-w-[1280px] px-5 py-10 md:px-10">
        <p className="font-mono text-[var(--signal)]" data-testid="portal-emp-code">{user.emp_code}</p>
        <h1 className="font-display text-5xl font-black uppercase md:text-7xl" data-testid="portal-name">Hello, {user.name?.split(" ")[0]}</h1>
        {(user.designation || user.site) && <p className="mt-1 text-[var(--bone-2)]">{[user.designation, user.site].filter(Boolean).join(" · ")}</p>}
        <div className="mt-10"><TodayCard onChange={loadAtt} /></div>
        <div className="mt-16 grid gap-14 lg:grid-cols-12">
          <section className="lg:col-span-7" data-testid="portal-attendance">
            <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
              <h2 className="font-display text-4xl font-black uppercase">My attendance</h2>
              <input type="month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className={`${boxInput} w-auto`} data-testid="portal-month-input" />
            </div>
            <AttendanceSummary records={att} />
            <div className="mt-6"><AttendanceTable month={month} records={att} /></div>
          </section>
          <section className="lg:col-span-5" data-testid="portal-payslips">
            <h2 className="mb-5 font-display text-4xl font-black uppercase">Salary slips</h2>
            <PayslipList slips={slips} />
          </section>
        </div>
      </div>
    </main>
  );
}
